import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnterpriseModalComponent } from 'src/app/Components/enterprise-modal/enterprise-modal.component';
import { MaterialModule } from 'src/app/models/material-components.service';
import { MaterialModuleList } from 'src/app/material-module';
import { HttpClientModule } from '@angular/common/http';



@NgModule({
  declarations: [
    EnterpriseModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    MaterialModuleList,
    FormsModule,
    HttpClientModule,
  ],
  exports: [
    EnterpriseModalComponent
  ]
})
export class EnterpriseModalModule { }
